<template>
    <div>
        <div>
            <div class="header" style="margin-bottom: 0.5em;font-size: 1.125em;line-height: 1.5em;">
                {{aoi.label}}
            </div>
            <div style="color: rgb(208, 208, 208);">
                <div>
                    <p style="margin-bottom: 2px">
                        {{formatCoords(aoi.center)}}
                    </p>
                    <p>
                        {{formatDate(aoi.start)+" — "+formatDate(aoi.end)}}
                    </p>
                </div>
            </div>
        </div>
        <div style="padding-right: 15px;padding-bottom: 10px;margin-top: 15px;display: flex;align-items: center">
            <div>
                <user-avatar :style="{width: '28px',height:'28px'}"
                             :img="aoi.userData.photoURL"
                />
            </div>
            <div style="padding-left: 10px">
                <div class="header"
                     style="margin-bottom: 0; font-size: 0.9em;  font-weight: 500;color: rgb(158, 157, 157)">
                    {{aoi.userData.displayName}}
                </div>
            </div>
            <p style="font-size: 0.85em;margin-left: auto;color: rgb(158, 157, 157)">
                {{formatTime(aoi.creationTime)}}
            </p>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import moment from 'moment'

    moment.locale('ru');

    import {formatCoords} from '@/lib/common-util'

    import UserAvatar from '@/components/user-avatar/user-avatar'

    export default {
        props: {
            aoi: {
                type: Object,
                required: true
            }
        },
        data() {
            return {}
        },
        computed: {},
        methods: {
            formatDate(date) {
                return moment(date).format("DD MMMM YYYY");
            },
            formatTime(time) {
                return moment(time).format("DD.MM.YYYY HH:mm");
            },
            formatCoords(coords) {
                return formatCoords(coords);
            }
        },

        components: {
            UserAvatar
        }
    }
</script>

<style scoped>

</style>
